import React from "react";
import './index.css';
import '../Banner/Banner.css';
import { Container, Row, Button } from "react-bootstrap";

const scrollToForm = () => {
  const formSection = document.getElementById('ContactMeForm');
  if (formSection) {
    const elementPosition = formSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset;
    const offsetValue = -80;
    window.scrollTo({
      top: offsetPosition + offsetValue,
      behavior: 'smooth'
    });
  }
 
};

const WhatIsCribEquity = ({ data }) => {
  // Safe destructuring with default values
  const { 
    title = "", 
    advantages = [], 
    keyTerms = [], 
    applyNowBtn = "", 
    getStartedBtnLink = "" 
  } = data?.whatIsCribEquity || {};

  // Early return if data isn't loaded yet
  if (!data) {
    return <div className="loading-placeholder">Loading...</div>;
  }

  return (
    <section id="program-highlights">
      <Container>
        <Row>
          <div className="btn-div-apply">
            <button className="apply-now-btn-dscr" onClick={scrollToForm}>{applyNowBtn}</button>
          </div>

          <div className="crib-equity-section">
            <div className='text-center whatistext'>
              <p>{title}</p>
            </div>
            <div className="crib-equity-content">
              <div className="crib-advantages">
                <ul>
                  {advantages.map((adv, index) => (
                    <li key={index}>{adv}</li>
                  ))}
                </ul>
              </div>

              <div className="crib-key-terms">
                <ul>
                  {keyTerms.map((term, index) => (
                    <li key={index} className="list-item">{term}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default WhatIsCribEquity;